import { get, keyBy, transform } from 'lodash'

import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = {}
const createFeatureMap = (features) => {
  const map = keyBy(features, 'Name')
  return transform(map, (result, feature, key) => {
    result[key] = feature.Enabled
  })
}

const featureToggleReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case types.FETCH_FEATURE_TOGGLES_SUCCESS:
      return {
        record: createFeatureMap(action.payload),
      }
    default:
      return state
  }
}

export default featureToggleReducer

export const selectFeatures = (store) => {
  return get(store.features, 'record')
}

export const selectFeature = (store, feature) => {
  const features = selectFeatures(store)
  return get(features, feature, false)
}

export const isConfigureUpcomingApplicationCycleEnabled = (store) => {
  return selectFeature(store, 'ConfigureUpcomingApplicationCycle')
}

export const isUseUpcomingApplicationCycleEnabled = (store) => {
  return selectFeature(store, 'UseUpcomingApplicationCycle')
}

export const isSSNStorageEnabled = (store) => {
  return selectFeature(store, 'SSNStorageEnabled')
}
export const isCommonAppShutdownEnabled = (store) => {
  return selectFeature(store, 'CommonAppShutdownEnabled')
}
export const isEnhancedManualRecAssignmentEnabled = (store) => {
  return selectFeature(store, 'EnhancedManualRecAssignment')
}

export const isGoogleMapsFeatureEnabled = (store) => {
  return selectFeature(store, 'EnableGoogleMaps')
}

export const isGenderPronounConfigEnabled = (store) => {
  return selectFeature(store, 'GPConfig')
}

export const isAcceptanceLikelihoodEnabled = (store) => {
  return selectFeature(store, 'AcceptanceLikelihoodFilters')
}

export const isTnTSearchFilterEnabled = (store) => {
  return selectFeature(store, 'TnTSearchFilter')
}

export const isAppStrategyEnabled = (store) => {
  return selectFeature(store, 'AppStrategy')
}

export const isPlanParentAudienceEnabled = (store) => selectFeature(store, 'PlanParentAudience')

export const isContactPreferenceSurveyEnabled = (store) => {
  return selectFeature(store, 'StudentContactPreferenceSurvey')
}
export const isNLPCollegeSearchEnabled = (store) => {
  return selectFeature(store, 'NLPCollegeSearch')
}
